<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><em class="italic">Part One<br/></em>THE FOURTH FLOOR</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// theviennamelody_00003.vue?4d8235e9